import Joi from '@hapi/joi';
import { sameCode } from './codes';

const baseObject = { code: '', name: '', active: false };

const schema = Joi.object({
  code: Joi.string()
    .required()
    .messages({
      "any.required": `"Código fornecedor" campo de preenchimento obrigatório`,
      "number.empty": `"Código fornecedor" campo vazio`,
      "number.base": `"Código fornecedor" tem de ser um número`
    }),
  name: Joi.string()
    .min(3)
    .max(250)
    .required()
    .messages({ // .pattern(/^[a-zA-Z0-9\-_\s]+$/)
      "any.required": `"Nome" campo de preenchimento obrigatório`,
      "string.empty": `"Nome" campo vazio`,
      "string.min": `"Nome" tem de ter pelo menos 3 caracteres`,
      "string.max": `"Nome" só pode 250 caracteres máximo`,
      "string.pattern.base": `"Nome" só pode usar caracteres alfanuméricos e "-_ "`
    }),
  active: Joi.boolean()
    .required()
    .messages({
      "any.required": `"Activo" campo de preenchimento obrigatório`,
      "boolean.empty": `"Activo" campo vazio`,
      "boolean.base": `"Activo" tem de ser boleano`
    })
});

const supplierValidator = (newSupplier, suppliers) => {
  let error = undefined;
  let iSupplier = { ...baseObject, ...newSupplier };

  const baseObjectKeys = Object.keys(baseObject);
  Object.keys(iSupplier).forEach(k => {
    if (!baseObjectKeys.includes(k)) {
      delete iSupplier[k];
    }
  });

  // Validate data correctness
  const validateSupplier = schema.validate(iSupplier, { abortEarly: false });
  if (validateSupplier.error) {
    return { error: validateSupplier.error.details.map(obj => obj.message) };
  }

  suppliers.some(sup => {

    // Validation of a create or an update operation!
    if (!newSupplier.id || (newSupplier.id && newSupplier.id !== sup.id)) {
      if (sameCode(sup.code, iSupplier.code) || sup.name === iSupplier.name) {
        error = { error: 'Codigo fornecedor ou Nome de fornecedor repetido!' };
        return true;
      } else {
        return false;
      }
    }
    return false;
  });
  return error ? error : iSupplier;
};

export default supplierValidator;
